import { assocPath, map } from 'ramda';
import { combineReducers } from 'redux';

import fieldStateReducer from '@gef-ui/redux-common/reducers/fieldState';
import formStateReducer from '@gef-ui/redux-common/reducers/formState';
import globalErrorsReducer from '@gef-ui/redux-common/reducers/globalErrors';
import formReducer from '@gef-ui/redux-form/reducers/form';
import registeredFieldReducer from '@gef-ui/redux-form/reducers/registeredField';

const actionTypes = {
	SET_ALL_FIELDS_VALID: 'SET_ALL_FIELDS_VALID',
	SET_FORM_DESCRIPTOR: 'SET_FORM_DESCRIPTOR',
	UPDATE_FIELDS_STATE: 'UPDATE_FIELDS_STATE',
	UPDATE_FIELD_DESCRIPTOR: 'UPDATE_FIELD_DESCRIPTOR',
};

const setFieldsStateToValid = map((field) => ({
	...field,
	state: {
		pristine: true,
		valid: 'VALID',
	},
}));

const createActionConstant = (formName, actionName) => {
	return `${formName}/${actionName}`;
};

const registeredFieldsReducerFactory = (formName) => {
	const UPDATE_FIELDS_STATE = createActionConstant(formName, actionTypes.UPDATE_FIELDS_STATE);
	const SET_ALL_FIELDS_VALID = createActionConstant(formName, actionTypes.SET_ALL_FIELDS_VALID);

	return (state, action) => {
		/*
		This is reacting on "app/RESET_REDUCERS" action,
		will not remove registred fields but set them to valid state
		*/
		if (typeof state === 'undefined' && action.type === 'OLD_STATE') {
			return registeredFieldReducer(formName)(setFieldsStateToValid(action.payload.registeredFields), action);
		}
		switch (action.type) {
			case UPDATE_FIELDS_STATE:
			case SET_ALL_FIELDS_VALID:
				return fieldStateReducer(formName)(state, action);
			default:
				return registeredFieldReducer(formName)(state, action);
		}
	};
};

const fieldDescriptorReducerFactory = (mapper, formName) => {
	const UPDATE_FIELD_DESCRIPTOR = createActionConstant(formName, actionTypes.UPDATE_FIELD_DESCRIPTOR);
	const SET_FORM_DESCRIPTOR = createActionConstant(formName, actionTypes.SET_FORM_DESCRIPTOR);

	return (state = mapper, action) => {
		const { descriptor, fieldName } = action;

		switch (action.type) {
			case UPDATE_FIELD_DESCRIPTOR:
				return assocPath([fieldName, 'descriptor'], descriptor, state);
			case SET_FORM_DESCRIPTOR:
				return descriptor;
			default:
				return state;
		}
	};
};

const formReducerFactory = (formName, mapper = {}, initialData = {}) => {
	return combineReducers({
		registeredFields: registeredFieldsReducerFactory(formName),
		globalErrors: globalErrorsReducer(formName),
		status: formStateReducer(formName),
		formData: formReducer(formName, initialData),
		fieldDescriptor: fieldDescriptorReducerFactory(mapper, formName),
	});
};

export default formReducerFactory;
